import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import type { SubstanceCalculationDto } from '@mobiletract/kobize-service-angular-client';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-report-calculation-summary',
  standalone: true,
  imports: [CommonModule, TranslateModule, SkeletonModule, TableModule],
  templateUrl: './report-calculation-summary.component.html',
  styleUrl: './report-calculation-summary.component.css'
})
export class ReportCalculationSummaryComponent {
  @Input() substances: SubstanceCalculationDto[] = [];
  @Input({ required: true }) totalEmission!: number;
  @Input() loading = false;
  @Input() reportId: string | null = null;

  get rows(): SubstanceCalculationDto[] {
    return this.substances ?? [];
  }

  get summaryStateKey(): string {
    const reportPart = String(this.reportId ?? 'unknown-report').trim() || 'unknown-report';
    return `summary#${reportPart}`;
  }
}
